/**
 * dataLayer helpers for the GTM container that spaik.io also uses
 * (GTM-5CM7WLBJ). Event names follow spaik-website/docs/TRACKING_PLAN.md:
 * generate_lead is the lead event spaik.io uses too, the rest are
 * ai_discovery_* events for the funnel in GA4. The container has no Google Ads
 * tag (16 okt 2026): Ads only sees these leads if they are imported from GA4.
 */

type DataLayerValue = string | number | boolean | undefined | Record<string, string>

declare global {
  interface Window {
    dataLayer?: Record<string, DataLayerValue>[]
  }
}

export function pushEvent(event: string, params?: Record<string, string | number | boolean | undefined>) {
  if (typeof window === 'undefined') return
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({ event, ...params })
}

export function pushPageContext(pageType: 'ai_discovery_intake' | 'ai_discovery_report') {
  pushEvent('page_context', { page_type: pageType, page_locale: 'nl' })
}

/** Same shape as pushGenerateLead on spaik.io, so the same GTM triggers apply. */
export function pushGenerateLead(params: { email?: string | null; value?: number }) {
  if (typeof window === 'undefined') return
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({
    event: 'generate_lead',
    form_name: 'ai_discovery',
    lead_source: 'ai_discovery',
    value: params.value ?? 500,
    currency: 'EUR',
    ...(params.email ? { enhanced_conversion_data: { email: params.email } } : {}),
  })
}
